import {Icon} from 'platform/foundation';

import {useGetMyTasksCountQuery} from '@dms/api/core';
import {UserSidebarIconSize} from '@dms/api/shared';
import {useFocusControl} from '@dms/shared';
import {TaskCenterHeaderButton} from '@dms/task-manager';

import {isDefinedNonZeroValue, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {SIDEBAR_MOBILE_ICON_SIZE} from '../constants/sidebarMobileIconSize';
import {useIsMobileNavigation} from '../hooks/useIsMobileNavigation';
import {formatBadgeNumber} from '../utils/formatBadgeNumber';
import {NavigationButton} from './NavigationButton';

interface TaskCenterButtonProps extends RequiredTestIdProps {
  isOpen: boolean;
  iconSize: UserSidebarIconSize;
}

function TaskCenterButtonMobile(props: TaskCenterButtonProps) {
  const {data: tasksCounts} = useGetMyTasksCountQuery();
  const {isDisabled} = useFocusControl();

  return (
    <NavigationButton
      isActive={props.isOpen}
      badgeValue={
        isDefinedNonZeroValue(tasksCounts?.count) ? formatBadgeNumber(tasksCounts.count) : undefined
      }
      tabIndex={isDisabled ? -1 : 0}
      data-testid={suffixTestId('task-center', props)}
    >
      <Icon
        size={SIDEBAR_MOBILE_ICON_SIZE}
        value="action/assignment_turned_in"
        color="text.white"
      />
    </NavigationButton>
  );
}

export function TaskCenterButton(props: TaskCenterButtonProps) {
  const isMobileNavigation = useIsMobileNavigation();

  if (isMobileNavigation) {
    return <TaskCenterButtonMobile {...props} />;
  }

  return <TaskCenterHeaderButton {...props} />;
}
